/* projects/family-portal/src/app/components/family-footer/family-footer.component.scss */
family-footer {
  display: block;
  width: 100%;
  min-height: 24px;
  background-color: var(--color-app-default-bg);
}
family-footer .family-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 767px) {
  family-footer .family-footer {
    padding: 16px;
    max-width: 300px;
    flex-direction: column;
    text-align: center;
    margin: auto;
    gap: 8px;
  }
}
family-footer .emergency-text {
  color: var(--color-grey);
  font-size: var(--font-xs);
  font-style: italic;
  line-height: 16.8px;
}
family-footer .footer-links {
  gap: 16px;
  display: flex;
}
family-footer .footer-link {
  display: flex;
  align-items: center;
  font-size: var(--font-xxs);
  font-weight: var(--font-weight-bold);
  line-height: 14px;
}
family-footer a {
  color: var(--color-grey);
  text-decoration: none;
}
family-footer nv-logo {
  height: 24px;
  width: 24px;
}
/*# sourceMappingURL=family-footer.component-JYIU33RJ.css.map */
